/* import __COLOCATED_TEMPLATE__ from './slack-integration-alert.hbs'; */
/* RESPONSIBLE TEAM: team-omni */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import type Store from '@ember-data/store';
import type SlackIntegrationModel from 'embercom/models/slack/integration';

interface Signature {
  Element: HTMLElement;
  Args: {};
}

export default class SlackIntegrationAlert extends Component<Signature> {
  @service declare store: Store;
  @service declare appService: $TSFixMe;

  @tracked hasStaleIntegration = false;

  constructor(owner: any, args: any) {
    super(owner, args);
    taskFor(this.loadSlackIntegration).perform();
  }

  @dropTask
  *loadSlackIntegration(): TaskGenerator<void> {
    let integrations = yield this.store.query('slack/integration', {
      app_id: this.appService.app.id,
    });
    this.hasStaleIntegration = integrations
      .toArray()
      .some((integration: SlackIntegrationModel) => integration.stale);
  }

  get isStale(): boolean {
    return this.hasStaleIntegration;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::SlackIntegrationAlert': typeof SlackIntegrationAlert;
    'new-settings/channels/slack-integration-alert': typeof SlackIntegrationAlert;
  }
}
